import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./Accordion.module.css";
import { ChevronDown } from "lucide-react";

export default function Accordion({ title, icon, data }) {
    const [isOpen, setIsOpen] = useState(false);
    const { pathname } = useLocation();
    const isAccordionActive = pathname.includes(title)

    return (
        <div className={`${styles.accordion} ${isOpen ? styles.active : ""}`}>
            <div className={`${styles.accordionItem}`}>
                <h2 className="accordion-header">
                    <li
                        onClick={() => setIsOpen(!isOpen)}
                        className={`${styles.navItem} `}
                    >
                        {icon && (
                            <span className={styles.icon}>
                                <img src={icon} className={styles.icon_img} alt={`${title} icon`} />
                                {title}
                            </span>
                        )}

                        <span className={`${styles.arrow} ${isOpen ? styles.rotate : ""}`}>
                            <ChevronDown color="#fff" size={20} />
                        </span>
                    </li>
                </h2>

                {isOpen && (
                    <div className={styles.accordionBody}>
                        <ul className="navbar-nav">
                            {data.map((item) => (
                                <li
                                    key={item.path}
                                    className={` ${styles.navItem} ${pathname.includes(item.path) ? styles.active : ""
                                        }`}
                                >
                                    <Link to={item.path} className={`nav-link ms-3 ${styles.link}`}>
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
}
